<template>
	<div class="register-page-commodity">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>
		
		<!-- 打开QIUI 没有打开成功 就跳转其他页面 -->
		<van-overlay :show="isOpenLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000002') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 轮播图 -->
		<van-swipe :autoplay="3000" class="carousel-container">
			<van-swipe-item v-for="(image, index) in images" :key="index">
				<img v-lazy="image" class="carousel-slide" />
			</van-swipe-item>
		</van-swipe>

		<!-- 商品信息 -->
		<div class="product-container">

			<div class="adiv">
				<div class="left-content">
					<span class="left-content">￥</span>
					<span class="price">{{ price }}</span>
				</div>
				<span class="sales">{{ $t('language000021') }}:{{ sales }}</span>
			</div>

			<div class="bdiv">
				<div class="product-name">{{ truncateText(name, 2) }}</div>
			</div>
		</div>

		<!-- 选择 -->
		<div style="display: flex; align-items: center; padding: 0 20px;">
			<span style="flex: 1; text-align: start; font-size: 14px; color: black;">{{$t('language000013')}}</span>
			<span
				style="flex: 2; text-align: end; font-size: 14px; color: #999; padding-right: 5px;">{{ skuChoose }}</span>
			<img style="width: 10px; height: px;" src="../assets/right_grey.png" />
		</div>

		<div style="background: #f7f7f7; height: 1px; margin: 10px 20px;"></div>

		<!-- 快递 -->
		<div style="display: flex; align-items: center; padding: 0 20px;">
			<span style="flex: 1; text-align: start; font-size: 14px; color: black;">{{$t('language000014')}}</span>
			<span
				style="flex: 2; text-align: end; font-size: 14px; color: #999; padding-right: 5px;">{{ productAppoint }}</span>
		</div>

		<!-- 宝贝详情 文案-->
		<div style=" display: flex; align-items: center; padding: 5px 20px 10px 20px;">
			<div style=" flex: 1; background: #ddd; height: 1px; margin: 10px 20px;"></div>
			<span style="color: #000; font: bold;">{{ $t('language000029') }}</span>
			<div style="flex: 1; background: #ddd; height: 1px; margin: 10px 20px;"></div>
		</div>

		<!-- 宝贝详情 图片 -->
		<div class="image-container-commodity" v-for="(image, index) in imageList" :key="index">
			<img :src="image" :alt="image" style="max-width: 100%;" />
		</div>

		<!-- 立即购买 -->
		<van-goods-action style="padding-bottom: 10px; background-color: #fff;">
			<van-goods-action-icon icon="chat-o" :text="$t('language000016')" @click="openQIUI" />
			<van-goods-action-icon icon="cart-o" :text="$t('language000017')" @click="openQIUI" />
			<van-goods-action-icon icon="shop-o" :text="$t('language000018')" @click="openQIUI" />
			<van-goods-action-button type="warning" :text="$t('language000019')" @click="openQIUI" />
			<van-goods-action-button type="danger" :text="$t('language000020')" @click="openQIUI" />
		</van-goods-action>


		<!-- 底部填充布局 -->
		<p style="height: 20px;"></p>

	</div>

</template>

<script>
	import axios from 'axios';
	import Hammer from 'hammerjs'; //手势监听

	import 'vant/lib/index.css'; //导入样式
	import Vue from 'vue';
	import {
		GoodsAction,
		GoodsActionIcon,
		GoodsActionButton,
		Search,
		Swipe,
		SwipeItem,
		Lazyload,
		Cell,
		CellGroup,
		Divider,
		Loading,
		Overlay,
	} from 'vant';

	Vue.use(GoodsAction);
	Vue.use(GoodsActionButton);
	Vue.use(GoodsActionIcon);
	Vue.use(Search);
	Vue.use(Swipe);
	Vue.use(SwipeItem);
	Vue.use(Lazyload);
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(Divider);
	Vue.use(Loading);
	Vue.use(Overlay);


	export default {
		name: 'Commodity',
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				isOpenLoading: false, //打开QIUI的提示框
				pid: null, // 商品ID
				images: [], // 从后台获取的图片列表
				currentIndex: 0, // 当前显示图片的索引
				price: 0, //价格
				sales: 0, //销量
				name: "", //商品名称
				skuChoose: 0, //sku的种类选择
				productAppoint: "", //快递的类型
				imageList: [], // 商品详情图片
			};
		},
		mounted() {
			this.pid = this.$route.params.pid;

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;

			this.fetchData();
		},
		methods: {
			fetchData() {
				this.isDataLoading = true;
				axios.post(this.$p_url_shop + '/api/front/h5Spread/getH5Detail', {
						pid: this.pid, //商品id
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("返回的值：", response.data)
						if (response.data.code === 200) {
							const data = response.data.data;
							// 商品轮播图
							const sliderImage = data.productInfo.sliderImage;
							this.images = sliderImage
								.substring(1, sliderImage.length - 1)
								.replace(/"/g, '')
								.split(',')
								.map(item => this.$p_urlImage + item.trim());

							//价格
							this.price = data.productInfo.price;
							//销量
							const ficti = data.productInfo.ficti; //虚拟销量
							const sales = data.productInfo.sales; //真实销量
							this.sales = ficti + sales;
							//名称
							this.name = data.productInfo.name;

							//sku种类选择
							const productValueListLength = data.productValueList.length;
							const languageText = this.$t('language000023');
							this.skuChoose = `${productValueListLength} ${languageText}`;

							//快递 0 全国包邮,1 部分包邮 ,2 自定义
							if (data.productAppoint == 0) {
								this.productAppoint = this.$t('language000024');
							} else if (data.productAppoint == 1) {
								this.productAppoint = this.$t('language000025');
							} else {
								this.productAppoint = this.$t('language000026');
							}


							//商品详情
							const content = data.productInfo.content;
							this.imageList = content
								.substring(1, content.length - 1)
								.replace(/"/g, '')
								.split(',')
								.map(item => this.$p_urlImage + item.trim());



						} else {
							alert('接口失败：' + response.data.code);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						alert("请求失败：" + error);
					});
			},
			truncateText(text, maxLines) { // 截取文本并在末尾添加"..."
				const lines = text.split('\n');
				if (lines.length > maxLines) {
					return lines.slice(0, maxLines).join('\n') + '...';
				}
				return text;
			},
			openQIUI() { // 在这里可以添加打开 QIUI 的逻辑
				this.isOpenLoading = true; //显示加载中
				const u = navigator.userAgent;
				window.location.href = this.$p_urlScheme + "CommodityInfo?id=" + this.pid;
				setTimeout(() => {
					this.isOpenLoading = false;
					//检测页面是否隐藏，通常用于判断用户是否切换到其他应用或标签。
					let hidden = window.document.hidden || window.document.mozHidden || window.document
						.msHidden || window.document.webkitHidden
					//如果页面未隐藏，表示用户留在当前页面。 表示没有跳转成功
					if (typeof hidden == "undefined" || hidden == false) {

						/* //跳转到注册页面
						this.$router.push({
							name: 'register'
						}); */
						
						//跳转到下载页面
						this.$router.push({
							name: 'download'
						});

					}
				}, 3000); //延迟3秒执行
			},
		},
	};
</script>

<style>
	/* 引入外部的CSS文件 */
	@import '../css/commodity.css';
</style>